export const isLoggedSelector = (state) => state.authReducer.isLogged;
